import queryString from 'query-string';
const query = queryString.parse(document.location.search);
export const showThreads = query.showThreads ? true : false;
